import * as React from 'react';
const Locator = (props: any) => {
  const { width = 24, height = 24 } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" {...props}>
      <mask
        id="a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#171717"
          d="M12 20.94a1.78 1.78 0 0 1-.585-.1 1.543 1.543 0 0 1-.528-.313 36.749 36.749 0 0 1-2.52-2.555 22.896 22.896 0 0 1-2.04-2.628 14.03 14.03 0 0 1-1.37-2.604c-.337-.86-.505-1.69-.505-2.492 0-2.308.746-4.176 2.24-5.605C8.183 3.214 9.953 2.5 12 2.5s3.816.714 5.309 2.143c1.492 1.43 2.239 3.297 2.239 5.605 0 .801-.168 1.63-.505 2.488a14.402 14.402 0 0 1-1.366 2.603 21.949 21.949 0 0 1-2.035 2.628 37.426 37.426 0 0 1-2.519 2.55 1.561 1.561 0 0 1-.53.318c-.197.07-.395.105-.593.105Zm.002-9.075c.497 0 .923-.177 1.276-.531.353-.354.53-.78.53-1.278s-.178-.923-.532-1.276a1.745 1.745 0 0 0-1.278-.53c-.497 0-.923.177-1.276.531-.353.355-.53.78-.53 1.278s.177.923.532 1.277c.354.353.78.53 1.278.53Z"
        />
      </g>
    </svg>
  );
};
export default Locator;
